import { createSlice } from '@reduxjs/toolkit';

import { ClientState, DateTypes } from '../../types/client';
import { INITIAL_LIST_PARAMS } from 'config';

const initialState: ClientState = {
  isLoading: false,
  clientList: {},
  clientListParams: INITIAL_LIST_PARAMS,
  filtersListParams: INITIAL_LIST_PARAMS,
  tableFiltersListParams: INITIAL_LIST_PARAMS,
  filtersErrors: {
    [DateTypes.CREATED_AT_START]: '',
    [DateTypes.CREATED_AT_END]: '',
    [DateTypes.PAID_AT_START]: '',
    [DateTypes.PAID_AT_END]: '',
    product_ids: '',
  },
  clientFreezeData: {},
};

const slice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getClientListSuccess(state, action) {
      state.isLoading = false;
      state.clientList = action.payload;
    },

    getClientSuccess(state, action) {
      state.isLoading = false;
      state.client = action.payload;
    },

    setClientListParams(state, action) {
      state.clientListParams = action.payload;
    },

    setFiltersListParams(state, action) {
      state.filtersListParams = action.payload;
    },

    setFiltersErrors(state, action) {
      state.filtersErrors = action.payload;
    },

    setClientFreezeSuccess(state, action) {
      state.clientFreezeData = action.payload;
    },

    setTableFiltersListParams(state, action) {
      state.tableFiltersListParams = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getClientListSuccess,
  getClientSuccess,
  setClientListParams,
  setFiltersListParams,
  setFiltersErrors,
  setClientFreezeSuccess,
  setTableFiltersListParams,
} = slice.actions;
